import {Component, OnInit} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

@Component({
    selector: "fhm-user-search-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./user-search-page.component.html",
    standalone: false
})
export class UserSearchPageComponent implements OnInit {

    gridData: any[] = [];


    constructor(private http: HttpClient,
                private auth: AuthApiService,
                private router: Router,
                private errorHandler: ErrorHandlerService,
                private spinnersService: FUISpinnersService) {
    }

    ngOnInit(): void {
        this.load();

    }

    load(): void {
        this.spinnersService.open();
        this.http.get<any[]>("/fonzie/users", {headers: this.auth.getHttpHeaderOptions()})
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe(data => {
                this.spinnersService.close();
                this.gridData = data;
            });
    }

    recordSelected(record: any): void {
        this.router.navigate(["/main/user-edit/" + record["email"]]);
    }

}
